import React, { useState, useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Contact from './pages/Contact';
import Projects from './pages/Projects';
import Assessment from './pages/Assessment';
import StudentDashboard from './pages/StudentDashboard';
import AdminDashboard from './pages/AdminDashboard';
import './App.css';
import { AuthProvider } from './AuthContext';
import ADCA from './pages/courses/computer/ADCA';
import OLevel from './pages/courses/computer/OLevel';
import ALevel from './pages/courses/computer/ALevel';
import Gallery from './pages/Gallery';
import Downloads from './pages/Downloads';
import FAQ from './pages/FAQ';
import Mission from './pages/Mission';
import Leadership from './pages/Leadership';
import Vocational from './pages/Vocational';
import ShortTerm from './pages/ShortTerm';
import Inquiry from './pages/Inquiry';
import Support from './pages/Support';
import StudentLogin from './pages/StudentLogin';
import StudentPortal from './pages/StudentPortal';
import Results from './pages/Results';
import CenterLogin from './pages/CenterLogin';
import CenterPortal from './pages/CenterPortal';
import FranchiseApply from './pages/FranchiseApply';
import FranchiseLogin from './pages/FranchiseLogin';
import Management from './pages/Management';
import TeacherDashboard from './pages/TeacherDashboard';
import { getAuth, onAuthStateChanged } from 'firebase/auth';

const ProtectedRoute = ({ children }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const auth = getAuth();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setIsAuthenticated(!!user);
      setIsLoading(false);
    });

    return () => unsubscribe();
  }, [auth]);

  if (isLoading) {
    return <div>Loading...</div>; // You can replace this with a loading spinner
  }

  if (!isAuthenticated) {
    return <Navigate to="/student/login" />;
  }

  return children;
};

const App = () => {
  return (
    <AuthProvider>
      <div className="app">
        <Header />
        <div className="main-content">
          <Routes>
            {/* Main Routes */}
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/projects" element={<Projects />} />
            
            {/* About Dropdown Routes */}
            <Route path="/about/mission" element={<Mission />} />
            <Route path="/about/leadership" element={<Leadership />} />
            <Route path="/about/management" element={<Management />} />
            
            {/* Student Routes */}
            <Route path="/StudentDashboard" element={
              <ProtectedRoute>
                <StudentDashboard />
              </ProtectedRoute>
            } />
            <Route path="/student/login" element={<StudentLogin />} />
            <Route path="/student/portal" element={<StudentPortal />} />
            <Route path="/student/results" element={<Results />} />
            
            {/* Center Routes */}
            <Route path="/center/login" element={<CenterLogin />} />
            <Route path="/center/portal" element={<CenterPortal />} />
            
            {/* Franchise Routes */}
            <Route path="/franchise/apply" element={<FranchiseApply />} />
            <Route path="/franchise/login" element={<FranchiseLogin />} />
            
            {/* Course Routes */}
            <Route path="/courses/computer/adca" element={<ADCA />} />
            <Route path="/courses/computer/o-level" element={<OLevel />} />
            <Route path="/courses/computer/a-level" element={<ALevel />} />
            
            {/* Get in Touch Routes */}
            <Route path="/contact/inquiry" element={<Inquiry />} />
            <Route path="/contact/support" element={<Support />} />
            
            {/* Other Routes */}
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/downloads" element={<Downloads />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/assessment" element={<Assessment />} />
            <Route path="/vocational" element={<Vocational />} />
            <Route path="/shortterm" element={<ShortTerm />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
            <Route path="/AdminDashboard" element={<AdminDashboard />} />
            <Route path="/TeacherDashboard" element={<TeacherDashboard />} />
          </Routes>
        </div>
        <Footer />
      </div>
    </AuthProvider>
  );
};

export default App;
